import { catchError, filter, map, Observable, of, take, tap } from 'rxjs';
import { ComponentDataSourceService } from '../../component-data-source.service';
import { LocationDTO } from '../../../../dto/location/location.dto';
import { Location } from '../../../../models/location/Location.model';
import { LoadDataParams } from '../../../../interfaces/DataSource/DataSourceParams.interface';
import { Router } from '@angular/router';
import { environment } from '../../../../environment/environment';
import { UserDTO } from '../../../../dto/users/user.dto';
import { AuthService } from '../../../auth/auth.service';

export function locations(componentDataSourceService: ComponentDataSourceService) {
    const router = componentDataSourceService.injector.get(Router);
    const ALLOWED_ROLES = ['orgadmin', 'superadmin', 'orgbruger', 'uddansvarlig', 'bruger', 'oevrig'];
    const authService  = componentDataSourceService.injector.get(AuthService);

    // Define columns statically like brugere_status.ts - no dynamic modification
    const columns = [
      { key: 'locations_name', header: 'Navn', type: 'text', sortable: true },
      { 
        key: 'firefighter_count', 
        header: 'Antal brandmænd', 
        type: 'number',
        alignment: 'center',
        sortable: true
      },
      { 
        key: 'ok_percentage', 
        header: 'STATUS (%)', 
        type: 'text',
        transform: (value: number) => `${value}%`,
        alignment: 'left',
        sortable: true
      },
      { 
        key: 'registered_percentage', 
        header: 'Tilmeldte', 
        type: 'component',
        componentName: 'duna-user-progress-label',
        componentInputs: (row: Location) => ({
          registeredPercentage: row.registered_percentage ?? 0,
          progressPercentage: row.progress_percentage ?? 0,
          showBreakdown: false,
          compact: true,
          aggregateContext: 'location',
        }),
        alignment: 'left',
        sortable: true
      },
      {
        key: 'actions',
        header: '',
        type: 'button',
        buttonText: 'Lokation',
        buttonColor: 'primary',
        variant: 'raised',
        alignment: 'right',
        action: (item: Location) => {
          router.navigate(['/lokation', item.guid]);
        }
      }
    ];

    return {
      name: 'Locations',
      description: 'List of all locations',
      execute: (params?: LoadDataParams) => {
        
        if (params?.sort) {
        } else {
        }
        
        return componentDataSourceService['loadDataWithStandardFiltersGET']('locations', '/locations/with-progress', params).pipe(
          catchError(error => {
            console.error('[locations] Error fetching locations (returning empty items):', error);
            return of({ items: [], totalCount: 0 });
          }),
          map(result => {
            if (result && result.items) {
              try {
                
                const locations = result.items.map((location: any) => {
                  const locationDTO: LocationDTO = {
                    guid: location.guid,
                    locations_name: location.locations_name,
                    clean_name: location.clean_name,
                    data: location.data || {},
                    rooms: location.rooms || [],
                    users: location.users || [],
                    registered_percentage: location.registered_percentage || 0,
                    progress_percentage: location.progress_percentage || 0,
                    ok_percentage: location.ok_percentage || 0,
                    firefighter_count: location.firefighter_count || 0
                  };
                  
                  const model = Location.fromDTO(locationDTO);
                  return model;
                });

                return {
                  items: locations,
                  totalCount: result.totalCount,
                  pageSize: result.pageSize,
                  pageIndex: result.pageIndex,
                  filters: result.filters
                };
              } catch (error) {
                console.error('[locations] Error converting DTO to Location:', error);
                return { items: [], totalCount: 0 };
              }
            } else {
              console.error('[locations] Unexpected response shape (no result.items) — throwing:', result);
              throw new Error('No locations found');
            }
          })
        );
      },
      settings: {
        /** CMS: use `DunaListLocationsComponent` instead of dynamic-table for list UI */
        listComponent: 'DunaListLocationsComponent',
        columns,
        pageable: true,
        sortable: true,
        rowHover: true,
        searchable: true,
        defaultSortColumn: 'locations_name',
        defaultSortDirection: 'asc'
      }
    };
} 